<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addMessage"
            >添加消息</el-button
          >
        </div>
        <div class="header-right">
          <div>
            <span>消息类型：</span>
            <el-select
              popper-class="screen-select"
              v-model="msgContentType"
              size="small"
              placeholder="请选择消息类型"
            >
              <el-option
                v-for="item in msgContentTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>推送类型：</span>
            <el-select
              v-model="msgPushType"
              size="small"
              placeholder="请选择推送类型"
            >
              <el-option
                v-for="item in msgPushTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>消息发送状态：</span>
            <el-select
              v-model="sendMsgStatus"
              size="small"
              placeholder="请选择消息发送状态"
            >
              <el-option
                v-for="item in sendMsgStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="messageList" style="width: 100%;">
            <el-table-column label="接收者" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.receiveUserId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="消息类型" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    msgContentTypeList.findIndex(
                      (val) => val.value == scope.row.msgContentType
                    ) != -1
                      ? msgContentTypeList[
                          msgContentTypeList.findIndex(
                            (val) => val.value == scope.row.msgContentType
                          )
                        ].label
                      : ""
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="消息标题" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.msgTitle }}</div>
              </template>
            </el-table-column>
            <el-table-column label="消息内容" align="center">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.msgContent }}</div>
              </template>
            </el-table-column>
            <el-table-column label="消息资源链接" align="center">
              <template slot-scope="scope">
                <a :href="scope.row.msgResLink" class="name">{{
                  scope.row.msgResLink
                }}</a>
              </template>
            </el-table-column>
            <el-table-column label="推送类型" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    msgPushTypeList.findIndex(
                      (val) => val.value == scope.row.msgPushType
                    ) != -1
                      ? msgPushTypeList[
                          msgPushTypeList.findIndex(
                            (val) => val.value == scope.row.msgPushType
                          )
                        ].label
                      : ""
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="消息发送状态" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    sendMsgStatusList.findIndex(
                      (val) => val.value == scope.row.sendMsgStatus
                    ) != -1
                      ? sendMsgStatusList[
                          sendMsgStatusList.findIndex(
                            (val) => val.value == scope.row.sendMsgStatus
                          )
                        ].label
                      : ""
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogcreateMessageVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        添加消息
      </div>
      <el-form
        :model="createMessageForm"
        :rules="createMessageFormRule"
        ref="createMessageForm"
        label-width="128px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="推送类型" prop="msgPushType">
          <el-select
            v-model="createMessageForm.msgPushType"
            size="small"
            placeholder="请选择推送类型"
          >
            <el-option
              v-for="item in msgPushTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="会员手机号"
          prop="phoneNum"
          v-if="createMessageForm.msgPushType == 10"
        >
          <el-input
            v-model="createMessageForm.phoneNum"
            placeholder="请填写会员手机号"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息类型" prop="msgContentType">
          <el-select
            v-model="createMessageForm.msgContentType"
            size="small"
            placeholder="请选择消息类型"
          >
            <el-option
              v-for="item in msgContentTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消息标题" prop="msgTitle">
          <el-input
            v-model="createMessageForm.msgTitle"
            placeholder="请填写消息标题"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="msgContent">
          <el-input
            v-model="createMessageForm.msgContent"
            placeholder="请填写消息内容"
            size="small"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="消息资源链接" prop="msgResLink">
          <el-input
            v-model="createMessageForm.msgResLink"
            placeholder="请填写消息资源链接"
            size="small"
          ></el-input>
        </el-form-item> -->
        <template
          v-if="
            createMessageForm.msgContentType != 1 &&
              createMessageForm.msgContentType != 2
          "
        >
          <el-form-item label="活动标题" prop="msgCustomContent.pTile">
            <el-input
              v-model="createMessageForm.msgCustomContent.pTile"
              placeholder="请填写活动标题"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动内容" prop="msgCustomContent.pContent">
            <el-input
              v-model="createMessageForm.msgCustomContent.pContent"
              placeholder="请填写活动内容"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="截止时间" prop="msgCustomContent.time">
            <el-date-picker
              v-model="createMessageForm.msgCustomContent.time"
              type="datetime"
              placeholder="选择截止时间"
              size="small"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="券批次ID"
            prop="msgCustomContent.cashCouponBatchOrderId"
            v-if="
              createMessageForm.msgContentType == 5 ||
                createMessageForm.msgContentType == 6
            "
          >
            <el-select
              v-model="
                createMessageForm.msgCustomContent.cashCouponBatchOrderId
              "
              size="small"
              placeholder="请选择券批次ID"
            >
              <el-option
                v-for="item in cashCouponList[
                  this.createMessageForm.msgContentType
                ]"
                :key="item.cashCouponBatchOrderId"
                :label="item.title"
                :value="item.cashCouponBatchOrderId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createMessage" :loading="isSubmit">{{
          createMessageForm.lifePayInstitutionId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogcreateMessageVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopNoticeMessageList,
  getShopNoticeMessageListCount,
  createShopNoticeMessage,
  getCashCouponDtosForShoperSend,
} from "@/api/index.js";
export default {
  data() {
    return {
      msgContentType: "",
      msgPushType: "",
      sendMsgStatus: "",
      msgContentTypeListStatic: [
        {
          label: "全部",
          value: "",
        },
        // {
        //   label: "富文本",
        //   value: 1,
        // },
        // {
        //   label: "链接消息",
        //   value: 2,
        // },
        {
          label: "微信小程序订阅消息",
          value: 3,
        },
        {
          label: "支付宝小程序订阅消息",
          value: 4,
        },
        {
          label: "微信主动推券",
          value: 5,
        },
        {
          label: "支付宝主动推券",
          value: 6,
        },
      ],
      msgPushTypeListStatic: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "个人消息",
          value: 10,
        },
        {
          label: "群发",
          value: 11,
        },
      ],
      sendMsgStatusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未发送",
          value: 10,
        },
        {
          label: "未第三方推送",
          value: 40,
        },
        {
          label: "完成发送",
          value: 200,
        },
        {
          label: "发送失败",
          value: 400,
        },
      ],
      messageList: [],
      statusObj: {
        20: "审核失败",
        10: "审核中",
        30: "审核成功",
      },
      cashCouponList: {},
      selCard: "",
      searchInput: "",
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogcreateMessageVisible: false,
      createMessageForm: {
        phoneNum: "",
        msgContentType: 3,
        msgTitle: "",
        msgContent: "",
        msgResLink: "",
        msgCustomContent: {
          pTile: "",
          pContent: "",
          time: "",
          cashCouponBatchOrderId: "",
        },
        msgPushType: 10,
      },
      createMessageFormRule: {
        phoneNum: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的会员手机号",
            trigger: "blur",
          },
        ],
        msgTitle: [
          {
            required: true,
            message: "请填写消息标题 ",
            trigger: "blur",
          },
        ],
        msgContent: [
          {
            required: true,
            message: "请填写消息内容",
            trigger: "blur",
          },
        ],
        "msgCustomContent.pTile": [
          {
            required: true,
            message: "请填写活动标题",
            trigger: "blur",
          },
        ],
        "msgCustomContent.pContent": [
          {
            required: true,
            message: "请填写活动内容",
            trigger: "blur",
          },
        ],
        "msgCustomContent.time": [
          {
            required: true,
            message: "请选择截止时间",
            trigger: "blur",
          },
        ],
        "msgCustomContent.cashCouponBatchOrderId": [
          {
            required: true,
            message: "请填写券批次ID",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
    };
  },
  watch: {
    msgContentType(val) {
      this.getPageData();
    },
    msgPushType(val) {
      this.getPageData();
    },
    sendMsgStatus(val) {
      this.getPageData();
    },
    searchInput(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
  },
  computed: {
    msgContentTypeList() {
      return this.msgContentTypeListStatic.filter(
        (item) => item.value && item.value != 1 && item.value != 2
      );
    },
    msgPushTypeList() {
      return this.msgPushTypeListStatic.filter((item) => item.value);
    },
  },
  mounted() {
    if (this.$route.query.type == "addvip") {
      this.addMessage();
    }
    this.getPageData();
    this.getCashCouponDtosForShoperSend();
  },
  methods: {
    getCashCouponDtosForShoperSend() {
      getCashCouponDtosForShoperSend({
        msgContentType: 5,
      }).then((res) => {
        if (res.code == 1) {
          this.cashCouponList[5] = res.data;
        }
        if (res.code == -1) {
          this.cashCouponList[5] = [];
        }
      });
      getCashCouponDtosForShoperSend({
        msgContentType: 6,
      }).then((res) => {
        if (res.code == 1) {
          this.cashCouponList[6] = res.data;
        }
        if (res.code == -1) {
          this.cashCouponList[6] = [];
        }
      });
    },
    getPageData() {
      this.pageNo = 1;
      this.getShopNoticeMessageList();
      this.getShopNoticeMessageListCount();
    },
    getShopNoticeMessageList() {
      getShopNoticeMessageList({
        pageNo: this.pageNo,
        row: this.pageSize,
        msgContentType: this.msgContentType,
        msgPushType: this.msgPushType,
        sendMsgStatus: this.sendMsgStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.messageList = res.data;
        }
        if (res.code == -1) {
          this.messageList = [];
        }
      });
    },
    getShopNoticeMessageListCount() {
      getShopNoticeMessageListCount({
        msgContentType: this.msgContentType,
        msgPushType: this.msgPushType,
        sendMsgStatus: this.sendMsgStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getShopNoticeMessageList();
    },
    dialogClose() {
      (this.createMessageForm = {
        phoneNum: "",
        msgContentType: 3,
        msgTitle: "",
        msgContent: "",
        msgResLink: "",
        msgCustomContent: {
          pTile: "",
          pContent: "",
          time: "",
          cashCouponBatchOrderId: "",
        },
        msgPushType: 10,
      }),
        this.$refs.createMessageForm.resetFields();
    },
    addMessage() {
      this.dialogcreateMessageVisible = true;
    },
    createMessage() {
      this.$refs.createMessageForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createMessageForm));
          console.log(params);
          params.msgCustomContent.time = new Date(
            params.msgCustomContent.time
          ).pattern("yyyy-MM-dd HH:mm:ss");
          params.msgCustomContent = JSON.stringify(params.msgCustomContent);
          createShopNoticeMessage(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "创建成功",
                type: "success",
                duration: 2000,
              });
              this.getPageData();
              this.dialogcreateMessageVisible = false;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            setTimeout(() => {
              this.isSubmit = false;
            }, 500);
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    & > div {
      margin-left: 20px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
.screen-select {
  width: 200px;
}
</style>
